"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageProgressBar = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
/* Blast Imports */
require("./PackageProgressBar.scss");
var models_1 = require("@app/_state/models");
/**
 * Display the progress of a transfer,
 * used for full packages and individual files
 */
var PackageProgressBar = function (props) {
    var progressClassMap = new Map();
    progressClassMap.set(models_1.PackageTransferState.IN_PROGRESS, 'is-success');
    progressClassMap.set(models_1.PackageTransferState.COMPLETE, 'is-success');
    progressClassMap.set(models_1.PackageTransferState.FAILED, 'is-danger');
    progressClassMap.set(models_1.PackageTransferState.REMOVED, (props.transferredBytes === props.totalBytes) ? 'is-success' : 'is-orange');
    progressClassMap.set(models_1.PackageTransferState.STOPPED, 'is-orange');
    var progressClassName = props.state ? progressClassMap.get(props.state) : 'is-info';
    var progressProps = {
        className: classnames_1.default('progress package-progress', progressClassName, props.className ? props.className : ''),
        max: props.totalBytes
    };
    if (props.state && [models_1.PackageTransferState.FAILED, models_1.PackageTransferState.COMPLETE, models_1.PackageTransferState.STOPPED].includes(props.state)) {
        progressProps.value = props.totalBytes;
    }
    else if (props.transferredBytes > 0) {
        progressProps.value = props.transferredBytes;
    }
    return (react_1.default.createElement("progress", __assign({}, progressProps)));
};
exports.PackageProgressBar = PackageProgressBar;
